import Model, { attr, belongsTo } from '@ember-data/model';
import type { ModelRegistry } from 'ember-data/types/registries/model';

export enum SecurityDepositActionKind {
  override = 'override',
  settle = 'settle',
}

export interface ISecurityDepositActionMetadata {
  captured_amount?: number | string;
  released_amount?: number | string;
}

export default class SecurityDepositActionModel extends Model {
  @attr('boolean') overridden!: boolean;
  @attr('string') kind!: SecurityDepositActionKind;
  @attr('number') amount!: number;
  @attr() metadata?: ISecurityDepositActionMetadata;

  @belongsTo('booking', { inverse: 'securityDepositAction', async: false })
  booking!: ModelRegistry['booking'];

  get isSettle(): boolean {
    return this.kind === SecurityDepositActionKind.settle;
  }

  get capturedAmount(): number {
    return Number(this.metadata?.captured_amount ?? 0);
  }

  get releasedAmount(): number {
    return Number(this.metadata?.released_amount ?? 0);
  }
}

declare module 'ember-data/types/registries/model' {
  interface ModelRegistry {
    'security-deposit-action': SecurityDepositActionModel;
  }
}
